<div fxFlex="100" fxFlex.gt-sm="60" fxFlexOffset.gt-sm="20"
     style="margin-left: 10px; margin-right: 10px; margin-top: 20px;" fxLayout="wrap row" fxLayoutAlign="center">
  <mat-card style="width: 100%; box-shadow: none; border: solid 2px #01579b; margin-top: 50px;">
    <mat-card-header>
      <mat-card-title>
        Bestelldiagramm
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div id="divOrderChart">
        <canvas id="orderChart" style="background: lightgreen;"></canvas>
      </div>
      <div style="margin-top: 40px;">
        <button mat-raised-button color="primary" (click)="refreshOrderChart()">
          Aktualisieren
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
